module.exports = __webpack_public_path__ + "img/kv-banner4.0d37e04a.jpg";